import { render, staticRenderFns } from "./ProgramActions.vue?vue&type=template&id=524392ae&scoped=true"
import script from "./ProgramActions.vue?vue&type=script&lang=ts"
export * from "./ProgramActions.vue?vue&type=script&lang=ts"
import style0 from "./ProgramActions.vue?vue&type=style&index=0&id=524392ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524392ae",
  null
  
)

export default component.exports